import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface GuttersOrFasciaDownspoutProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const GuttersOrFasciaDownspout: React.FC<GuttersOrFasciaDownspoutProps> = ({
    required = false,
    propertyGuid,
    isReview = false,
}) => {
    const [guttersOrFasciaDownspout, set_guttersOrFasciaDownspout] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Exterior Structure']?.['Guters or Fascia, Downspout']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Structure': { ...b.values?.['Exterior Structure'], 'Guters or Fascia, Downspout': [b.values?.['Exterior Structure']?.['Guters or Fascia, Downspout']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Gutters or Fascia, Downspout';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(guttersOrFasciaDownspout)}
                />
            ) : (
                <MoneyBox
                    id={'guttersOrFasciaDownspout'}
                    allowNegative={false}
                    value={guttersOrFasciaDownspout}
                    onChange={(value) => set_guttersOrFasciaDownspout(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
